import { render, staticRenderFns } from "./LoginInToJoinIn.vue?vue&type=template&id=3cca8c5b&scoped=true"
import script from "./LoginInToJoinIn.vue?vue&type=script&lang=js"
export * from "./LoginInToJoinIn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cca8c5b",
  null
  
)

export default component.exports